// extracted by mini-css-extract-plugin
export default {"siderbarItems":"SidebarItems_siderbarItems__o4arU","active":"SidebarItems_active__BXaNk"};